export const AD_DEFAULT_WIDTH = 460;
export const AD_DEFAULT_HEIGHT = 280;

export const AD_MOBILE_WIDTH = 300;
export const AD_MOBILE_HEIGHT = 250;

export const AD_MIN_WIDTH_PX = 120;
export const AD_MIN_HEIGHT_PX = 50;

export const LIMIT_SIDE_PX = 450;
export const MAX_VALUE_WIDTH_HEIGHT_PX = 1200;

export const GAPI_AD_RESPONSIVE = '1x3';
